var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"card"},[_c('Flow')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }